export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/6ca19e876096cae3e2ee3e269668428e.svg";